import { render, staticRenderFns } from "./PropertyReactivationModal.vue?vue&type=template&id=bded9354&scoped=true&"
import script from "./PropertyReactivationModal.vue?vue&type=script&lang=js&"
export * from "./PropertyReactivationModal.vue?vue&type=script&lang=js&"
import style0 from "./PropertyReactivationModal.vue?vue&type=style&index=0&id=bded9354&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bded9354",
  null
  
)

export default component.exports